import { render } from "./FooterSectionThree.vue?vue&type=template&id=613f2f40"
import script from "./FooterSectionThree.vue?vue&type=script&lang=js"
export * from "./FooterSectionThree.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__